export const MESSAGES = {
  invalidPhoneNumber: 'Invalid phone number.',
  invalidUsernameOrPassword: 'Invalid username or password.',
  common: 'Something went wrong.',
  passwordStrength: 'Your password must have at least 8 characters, contain at least one number, one special character and a combination of uppercase and lowercase letters.',
  emailIsInvalid: 'Please enter a valid email address.',
  passwordNotMatch: 'Password does not match.',
  requiredField: (field: string) => `The ${field} Field is required.`,

  // returnNote
  radioField: (field: string) => `Please select ${field}.`,
  customerAutoComplete: 'Please select existing customer or create a new one.',
  selectCustomer: 'Please select customer.',
  invalidEquipmentQuantity: (min: number, max: number) => `Value must be between ${min} and ${max}.`,
  serialNoRequired: 'Please enter serial no.',
  serialNoMaxLength: 'Please enter maximum 9 digit serial no.',
  serialNoExist: 'Serial No already exist.',
  requiredValue: 'Please enter value.',
  voltagePattern: 'The value for Voltage(V) is not valid.',

  //Report
  invalidDate: 'Please enter a valid date.',
  formDate: 'The From Date cannot be greater than the To Date.',
  toDate: 'The To Date must be greater than the From Date.',

  // management
  countryList: 'Cannot able to fetch country list.'
}

export const TOAST_HEADER = {
  SUCCESS: 'Success',
  ERROR: 'Error'
}

export enum status {
  success = 200,
  badRequest = 400,
  unAuthorized = 401,
  notFound = 404
}

export const PrimaryColor = '#007ECC';

// export const BaseURL = process.env.NODE_ENV === 'development'
//   ? 'https://api-wittgas.azurewebsites.net' //'http://185.70.11.7:8060'
//   : 'http://185.70.11.7:8079';

export const BaseURL = process.env.REACT_APP_API_URL || "";
console.log("API URL:", process.env.REACT_APP_API_URL);